module.exports = __webpack_public_path__ + "img/slide04_m.1c85e3c8.jpg";